import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

declare var Liferay: any;

/**
 * Provide the user with a way to access the currently acive locale - the locale
 * is either derived from the navigator the user uses or queried from liferay if
 * run in a liferay environment
 */
@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  private language = new BehaviorSubject<string | null>(null);

  constructor() {
    this.updateInfo();
  }

  private updateInfo() {
    if (typeof Liferay === 'object') {
      const languageString = Liferay.ThemeDisplay.getLanguageId();
      if (languageString) {
        const languageElements = languageString.split('_', 2);
        if (languageElements.length > 0) {
          this.language.next(languageElements[0]);
        }
      }
    } else {
      const languageElements = navigator.language.split(/[_-]/, 2);
      if (languageElements.length > 0) {
        this.language.next(languageElements[0]);
      }
    }
  }

  getLanguage(): Observable<string | null> {
    return this.language;
  }

  getCurrentLanguage(): string | null {
    return this.language.value;
  }
}
